// Module
var code = "<div class=\"question-element\"> <p class=\"question text-style -para\">[[ text ]]</p> <div view=\"repeat\" data-items=\"[[ answers ]]\" data-as=\"answer\"> <div view=\"[[answer]]\" data=\"[[answer]]\"></div> </div> </div> ";
// Exports
export default code;